export default "__VITE_ASSET__CbQkKQE9__"